import { Component, inject, Signal } from '@angular/core';
import { AcceptCookies, MainState, TranslationPipe } from '@cloud-and-service/portal-lib';
import { Store } from '@ngxs/store';

@Component({
  selector: 'app-cookies',
  templateUrl: './cookies.component.html',
  styleUrls: ['./cookies.component.scss'],
  imports: [
    TranslationPipe,
  ],
})
export class CookiesComponent {
  private readonly store: Store = inject(Store);
  cookiesAccepted: Signal<boolean> = this.store.selectSignal(MainState.cookiesAccepted);

  acceptCookies() {
    this.store.dispatch(new AcceptCookies(true));
  }

  toggleDetails() {
    const wrapper = document.getElementById('coiConsentBannerCategoriesWrapper');
    if (wrapper) {
      const isHidden = wrapper.getAttribute('aria-hidden') === 'true';
      wrapper.setAttribute('aria-hidden', isHidden ? 'false' : 'true');
      wrapper.style.maxHeight = isHidden ? '1000px' : '0px';
    }
  }
}
